import React from 'react';

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DropDownIcon from './icons/DropDownIcon'
import lodash from "lodash"

class DropList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggle: this.props.isToggle || false,
      option: this.props.defaultOption || {label: 'All', value: null}
    }
  }

  toggle = () => this.setState({isToggle: !this.state.isToggle})

  onSelected(item) {
    this.setState({option: item})
    this.props.onChanged && this.props.onChanged(item)
  }

  componentDidUpdate(prevProp) {
    if (!lodash.isEqual(this.props.defaultOption, prevProp.defaultOption)){
      this.setState({option: this.props.defaultOption})
    }
  }
  
  render() {
    const selectedOption = this.state.option || {label: 'All', value: null}
    return (
      <Dropdown isOpen={this.state.isToggle} toggle={() => this.toggle()} className={`droplist ${this.props.className}`}>
        <DropdownToggle>
          <label>{selectedOption.label}</label>
          <DropDownIcon toggle={this.state.isToggle} />
        </DropdownToggle>
        <DropdownMenu>
          {(this.props.options || []).map(item => {
              const active = selectedOption.label === item.label ? 'active-opt' : ''
              return <DropdownItem className={active} key={item.label} onClick={() => this.onSelected(item)}>
                <label className={active} >
                  {item.label}
                </label>
                {active !== '' && <i className="fas fa-check"></i>}
              </DropdownItem>
          })}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default DropList;
